import React from 'react';
import 'react-phone-input-2/lib/material.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

function PhoneNumberInput(props) {
  const {
    placeholder = 'placeholder',
    title = 'title',
    error,
    className,
    onChange = () => {},
    value,
    country = 'us',
  } = props;

  return (
    <div className={`input-main-div ${className}`}>
      <div className="headingcontainer">
        <p className="input-div">
          {' '}
          {title}
        </p>
      </div>
      <PhoneInput
        placeholder={placeholder}
        title={title}
        value={value}
        onChange={onChange}
        enableAreaCodes={false}
        enableSearch
        country={country}
        preferredCountries={['us', 'gb', 'ca', 'au', 'pk', 'in', 'ae', 'sa']}
        countryCodeEditable={false}
        inputProps={{
          name: 'phone',
          required: true,
          autoFocus: false,
        }}
      />
      {error && <p className="InputErrorMsg">{error}</p>}
    </div>
  );
}

export default PhoneNumberInput;
